import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, Toolbar, IconButton, Button, Box, Tooltip, Drawer } from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import PersonIcon from "@mui/icons-material/Person";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import nanesa from "../../components/auth/theme/nanesa.png";

import { useAuth } from "../auth/AuthContext/AuthContext";

interface NavbarProps {
  toggleDarkMode: () => void;
  darkMode: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ toggleDarkMode, darkMode }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElMobile, setAnchorElMobile] = useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { isAuthenticated, userRole, logout } = useAuth();
  const navigate = useNavigate();

  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorElMobile(null);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    handleMenuClose();
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      {/* ------ DESKTOP ------ */}
      <AppBar position="static">
        <Toolbar
          sx={{
            minHeight: 64,
            backgroundColor: "rgb(190,209,113)",
            color: "#000000",
            "@media (min-width:600px)": {
              minHeight: 48,
            },
          }}
        >
          <IconButton
            edge="start"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{
              display: { xs: "flex", md: "none" },
              boxShadow: "none",
              borderRadius: "4px",
            }}
          >
            <MenuIcon />
          </IconButton>
          <img
            src={nanesa}
            alt="Description of image"
            style={{
              objectFit: "contain",
              width: "100px",
              height: "50px",
              marginRight: "69%",
            }}
          />
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              color="inherit"
              onClick={() => handleNavigation("/")}
              startIcon={<QrCode2Icon />} // Icon for shippings
              sx={{
                height: "30px",
              }}
            >
              Spedizioni
            </Button>
            {userRole === "1" && (
              <>
                <Button
                  color="inherit"
                  onClick={() => handleNavigation("/users/list")} // Navigate directly to /users/list
                  startIcon={<PersonIcon />}
                  sx={{
                    height: "30px",
                  }}
                >
                  Utenti
                </Button>
              </>
            )}
            <IconButton
              onClick={toggleDarkMode}
              sx={{
                color: "black",
              }}
            >
              {darkMode ?
                <DarkModeIcon />
              : <LightModeIcon />}
            </IconButton>
            {isAuthenticated && (
              <Tooltip title="Log out" arrow>
                <Button color="inherit" onClick={handleLogout} endIcon={<LogoutIcon />} />
              </Tooltip>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* ------ MOBILE ------ */}

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: "block", md: "none" },
        }}
      >
        <Box sx={{ width: "40vw" }}>
          <Button sx={{ width: "100%", display: "flex" }} color="inherit" onClick={() => handleNavigation("/")}>
            <QrCode2Icon />
            Progetti
          </Button>
          {userRole === "1" && (
            <>
              <Button
                color="inherit"
                onClick={() => handleNavigation("/users/list")} // Navigate directly to /users/list
                startIcon={<PersonIcon />}
                sx={{
                  height: "30px",
                  width: "100%",
                  display: "flex",
                }}
              >
                Utenti
              </Button>
            </>
          )}
          <IconButton onClick={toggleDarkMode} sx={{ width: "100%", display: "flex", color: darkMode ? "white" : "black" }}>
            {darkMode ?
              <DarkModeIcon />
            : <LightModeIcon />}
          </IconButton>
          {isAuthenticated && (
            <Button sx={{ width: "100%", display: "flex", color: darkMode ? "white" : "black" }} onClick={handleLogout}>
              <LogoutIcon />
              Logout
            </Button>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
